import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from './reactSelect/select.component';
import { calculationsOptionsSelector, calculationSelector, connectionByTypeSelector, periodOrCurrentSelector } from './store/selectors';
import { selectCalculation, fetchCalculationId } from './store/actions';
import { CalculationIdPropTypes, CalculationsIdPropTypes } from './propTypes/calculation';
import { ConnectionPropTypes } from './propTypes/connection';
import { PeriodPropTypes } from './propTypes/period';


class CalculationDropdown extends PureComponent {
  static propTypes = {
    calculations: PropTypes.arrayOf(CalculationsIdPropTypes).isRequired,
    calculationSelected: CalculationIdPropTypes,
    selectCalculation: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    connection: ConnectionPropTypes,
    period: PeriodPropTypes,
    fetchCalculationId: PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
  };

  componentDidMount() {
    const { fetchCalculationId, connection, period } = this.props;
    if (!!period && !!connection) {
      fetchCalculationId(connection.connName, period?.name);
    }
  }

  componentDidUpdate(prevProps) {
    const { fetchCalculationId, connection, period } = this.props;
    if (!!period && !!connection && (prevProps.connection?.connName !== connection?.connName)) {
      fetchCalculationId(connection?.connName, period?.name);
    }
  }

  onCalculationChange = selectedCalculation => {
    const { calculations, selectCalculation, onChange } = this.props;
    const calculationToSelect = selectedCalculation
      ? calculations.find(({ value }) => value === selectedCalculation?.value) : null;
    if (calculationToSelect) {
      selectCalculation(calculationToSelect);
      if (onChange) {
        onChange(calculationToSelect);
      }
    }
  };

  render() {
    const { calculationSelected, calculations, disabled } = this.props;
    const selectValue = calculationSelected?.value ? calculationSelected : null;

    return (
      <Select
        className="select-job-id"
        clearable={false}
        name="calculation"
        options={calculations}
        labelKey="label"
        onChange={this.onCalculationChange}
        disabled={disabled}
        scrollMenuIntoView={false}
        value={selectValue}
        virtualized
      />
    );
  }
}

export default connect(
  function mapStateToProps(state) {
    return {
      calculationSelected: calculationSelector(state),
      calculations: calculationsOptionsSelector(state),
      connection: connectionByTypeSelector(state),
      period: periodOrCurrentSelector(state),
    };
  },
  {
    selectCalculation,
    fetchCalculationId,
  }
)(CalculationDropdown);
